import { LinkButton } from '@cian/ui-kit';
import * as React from 'react';
import { ISuburbanProjectSuggest } from 'shared/types/suburbanBuildersProjects';

import * as styles from './SuburbanBuildersProjects.css';
import { ProjectItem } from './components/ProjectItem';

export interface ISuburbanBuildersProjectsProps {
  items: ISuburbanProjectSuggest[];
  link: string;
  onProjectClick(id: number, position: number): void;
  onAllProjectsButtonClick(): void;
}

export const SuburbanBuildersProjects: React.FC<ISuburbanBuildersProjectsProps> = ({
  items,
  link,
  onProjectClick,
  onAllProjectsButtonClick,
}) => {
  return (
    <div>
      <div className={styles['projects-list']}>
        {items.map((project, index) => (
          <ProjectItem
            {...project}
            key={project.projectId}
            onClick={() => onProjectClick(project.projectId, index + 1)}
          />
        ))}
      </div>
      <LinkButton size="XS" theme="fill_secondary" onClick={onAllProjectsButtonClick} href={link} target="_blank">
        Смотреть все проекты
      </LinkButton>
    </div>
  );
};
